const {createClient} = require("contentful");


module.exports = {
    createContentfulClient() {
        const config = {
            space: process.env.VUE_APP_CTF_SPACE_ID,
            accessToken: process.env.VUE_APP_CTF_CDA_ACCESS_TOKEN
        };
        return createClient(config)
    }
};
